import { createContext } from "react";

/**
 * The set of available alert types.
 */
export type AlertType = "success" | "warning" | "error" | "general-grey" | "general-dark" | "general-turquoise";

/**
 * The alert style.
 */
export type AlertStyle = "banner" | "toast";

/**
 * The alert data
 */
export interface AlertData {
  /**
   * The alert id.
   */
  readonly id?: string;

  /**
   * The alert message
   */
  readonly message: string | Error;

  /**
   * The type of the alert.
   */
  readonly type: AlertType;

  /**
   * The style of the alert.
   */
  readonly style: AlertStyle;

  /**
   * The timeout of the alert in ms: defaults to 5000.
   */
  readonly timeout?: number;
}

/**
 * The alert showing function.
 */
export interface ShowAlert {
  /**
   * Shows an alert
   */
  (alert: AlertData): void;
}

/**
 * The alert hiding function.
 */
export interface HideAlert {
  /**
   * Hides the current alert.
   */
  (): void;
}

/**
 * The alert context data.
 */
export interface AlertContextData {
  /**
   * Shows an additional alert.
   */
  showAlert: ShowAlert;

  /**
   * Hides a specific alert.
   */
  hideAlert: HideAlert;
}

/**
 * A no-operation function.
 */
const NoOp = (): void => {
  /** No operation */
};

/**
 * The alert context.
 * @deprecated Please use the component in `capitalrx-components-2.0/lib/general`.
 */
export const AlertContext = createContext<AlertContextData>({
  showAlert: NoOp,
  hideAlert: NoOp,
});
